export enum PermissionBit {
  SELECT = 0,
  CREATE = 1,
  READ = 2,
  UPDATE = 3,
  DELETE = 4,
  SPECIAL = 5,
}

export const PERMISSION_NAMES: Record<PermissionBit, string> = {
  [PermissionBit.SELECT]: 'Seleccionar',
  [PermissionBit.CREATE]: 'Crear',
  [PermissionBit.READ]: 'Leer',
  [PermissionBit.UPDATE]: 'Actualizar',
  [PermissionBit.DELETE]: 'Eliminar',
  [PermissionBit.SPECIAL]: 'Especial',
}

export class PermissionChecker {
  constructor(private userPermissions: number) {}

  can(permission: PermissionBit): boolean {
    const bitMask = 1 << permission
    return (this.userPermissions & bitMask) !== 0
  }

  canAll(...permissions: PermissionBit[]): boolean {
    return permissions.every((p) => this.can(p))
  }

  canAny(...permissions: PermissionBit[]): boolean {
    return permissions.some((p) => this.can(p))
  }

  canSelect(): boolean {
    return this.can(PermissionBit.SELECT)
  }

  canCreate(): boolean {
    return this.can(PermissionBit.CREATE)
  }

  canRead(): boolean {
    return this.can(PermissionBit.READ)
  }

  canUpdate(): boolean {
    return this.can(PermissionBit.UPDATE)
  }

  canDelete(): boolean {
    return this.can(PermissionBit.DELETE)
  }
}
